// @import dependencies
import { store } from 'app_storage/redux-storage'
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {DefaultHomeModuleLayout} from 'app_components/modules/homeScreens/defaultHome'
// @end

// @import events
import { changeScreenModeAction } from 'app_events/auth/actions'
// @end

// @import utils
import {Http, HttpCustomStructure} from 'app_utils/http'
import {I18nUtil} from 'app_utils/i18n'
import {SocketUtil} from 'app_utils/socket'
import WebSocketService from 'app_services/webSocket/webSocketService';
// @end

// @import services
import AuthService from 'app_services/secure/auth/authService'
import {routingService} from 'app_services/routingService'
// @end

// @import types
// @end

// @ADD Component types
interface IDefaultHomeModuleProps {
  // auth: any,
  history?: any
}
interface IDefaultHomeModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class DefaultHomeModule extends Component<IDefaultHomeModuleProps, IDefaultHomeModuleState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  user: any = null
  private socket: SocketUtil | null
  private webSocketService: WebSocketService
  storeObject = store

  constructor(props: IDefaultHomeModuleProps) {
    super(props)
    this.user = this.storeObject.getState().auth.user
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    this.webSocketService = WebSocketService.getInstance()
    this.socket = this.webSocketService.getSocketInstance()
    if (this.socket) {
      this.socket.listen('testing', (data: any) => {
        console.log('Recibio desde socket backend')
        console.log(data)
      })
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    if (this.socket) {
      this.socket.disconnect()
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  handleLogout = () => {
    const authService = new AuthService()
    authService.logout()
  }

  handleApiConnect = async () => {
    const query_data: HttpCustomStructure = {
      method: 'GET',
      url: `/`,
    }

    const data = await Http.send(query_data)
    console.log(data)
  }

  handleSocketConnect = () => {
    if (this.socket) {
      this.socket.emit('react-new-user')
    }
  }

  handleChangeLanguaje = () => {
    const i18nUtility = new I18nUtil()
    let language = 'en'
    if (i18nUtility.language() === 'en') language = 'es'
    i18nUtility.use(language)
  }

  handleGoToPage = () => {
    this.props.history.push(routingService.getSecurePath('/profile'))
  }

  handleChangeTheme = () => {
    const currentTheme = this.storeObject.getState().auth.user?.data?.screen_mode
    if (currentTheme === 'light-mode') {
      this.storeObject.dispatch(changeScreenModeAction('dark-mode'))
    } else {
      this.storeObject.dispatch(changeScreenModeAction('light-mode'))
    }
  }

  render() {
    return(
      <DefaultHomeModuleLayout
        user={this.user}
        onHandleApiConnect={this.handleApiConnect}
        onHandleSocketConnect={this.handleSocketConnect}
        onHandleChangeLanguaje={this.handleChangeLanguaje}
        onHandleGoToPage={this.handleGoToPage}
        onHandleLogout={this.handleLogout}
        onHandleChangeTheme={this.handleChangeTheme}
      />
    )
  }
}

export default connect(mapStatesToProps)(DefaultHomeModule)
